// @ts-nocheck
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC, useState } from "react";
import { useTheme } from "styled-components";

const errorText = "This field is invalid.";

const withIconProps: TextFieldProps = {
    iconProps: {
        src: "Search",
    },
};

const withClickableIconProps: TextFieldProps = {
    ...withIconProps,
    iconClickableProps: {
        onClick: () => {},
    },
    clickableText: "Search",
};

const Row: FC<TextFieldProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <TextField label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <TextField label={`${label} (Disabled)`} disabled {...props} />
        </GridItem>
        <GridItem width={4}>
            <TextField label={`${label} (Error)`} required error={errorText} {...props} />
        </GridItem>
    </>
);

const Variant: FC<TextFieldProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);
    const [sectionId] = useState(`subsection-${uniqueId()}`);

    return (
        <StyleguideSection variant="h3" title={upperFirst(sizeVariant)} sectionId={sectionId} isSubSection>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" sizeVariant={sizeVariant} />
                <Row label="Placeholder" sizeVariant={sizeVariant} placeholder="Enter some text here" />
                <Row label="Icon" sizeVariant={sizeVariant} {...withIconProps} />
                <Row label="Clickable Icon" sizeVariant={sizeVariant} {...withClickableIconProps} />
                <Row label="Animated" sizeVariant={sizeVariant} isAnimated={true} />
                <Row label="Inline" sizeVariant={sizeVariant} labelPosition="left" />
                <GridItem width={4}>
                    <TextField label="Hint" sizeVariant={sizeVariant} hint="This is a field description." />
                </GridItem>
                <GridItem width={4}>
                    <TextField
                        label="Hint &amp; Error"
                        sizeVariant={sizeVariant}
                        hint="This is a field description."
                        error={errorText}
                    />
                </GridItem>
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideTextFields: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Text Fields" sectionId={sectionId}>
            <Variant sizeVariant="default" />
            <Variant sizeVariant="small" />
            <Variant sizeVariant={"xsmall" as any} />
        </StyleguideSection>
    );
};

export default StyleguideTextFields;
